import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const BankOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="m20.18 7.74-7.1-4.13c-.6-.35-1.38-.35-1.98 0L4 7.74c-.64.37-.93 1.04-.75 1.7.2.73.9 1.22 1.75 1.22h1.43s-.01.04-.01.06v5.49H5.18c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h13.64c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8h-1.18v-5.49s-.01-.04-.01-.06h1.56c.85 0 1.55-.49 1.75-1.22.18-.66-.12-1.32-.75-1.7h-.01Zm-8.89 2.97v5.49H8.02v-5.49s-.01-.04-.01-.06h3.3s-.01.04-.01.06h-.01Zm4.75 0v5.49h-3.15v-5.49s-.01-.04-.01-.06h3.17s-.01.04-.01.06Zm3.14-1.66H4.94l6.97-4.06c.1-.06.27-.06.38 0l6.96 4.06H19.18ZM19.74 18.74H3.78c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h15.96c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default BankOutlined
